/**
 * RESPONSIBILITY: draw one core tenet as a card that goes to its ministry.
 *
 * The number is its position, drawn rather than stored: an editor who reorders the list
 * should not then have to renumber it.
 */
import type { Card } from '@app/sections';
import { Picture } from '../commons/Picture';

export interface AboutTenetCardProps {
  t: Card;
  index: number;
  /** The same words on every card, so they come from the section rather than from here. */
  linkLabel?: string;
}

export function AboutTenetCard({ t, index, linkLabel }: AboutTenetCardProps) {
  return (
    <a className="about-tenet-card" href={t.href || '#'}>
      <div className="about-tenet-pic-wrap">
        <Picture value={t.image} alt={t.image?.alt} className="card-pic" />
        <span className="about-tenet-num" aria-hidden="true">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>
      <div className="about-tenet-body">
        <h3>{t.title}</h3>
        {t.blurb && <p>{t.blurb}</p>}
        {linkLabel && <span className="about-tenet-link">{linkLabel}</span>}
      </div>
    </a>
  );
}
